import React, { useEffect, useState } from "react";
import "./NewsUpdates.css";
import axios from "axios";
import NewsBlock from "../components/NewsBlock";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NewsUpdates = () => {
  const [axiosData, setAxiosData] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState(44);
  const [pageCount, setPageCount] = useState(1);
  const [isCooldown, setIsCooldown] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [searchText, setSearchText] = useState("");

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const findPageCount = async (category_id) => {
    let result = await axios.get(
      `https://www.damenmc.com/wp-json/wp/v2/categories?per_page=100`
    );
    let newsFilter = result?.data.filter((item) => item.id === category_id);

    let postsCount = newsFilter[0].count;
    return Math.ceil(postsCount / 12);
  };

  const createPageButtons = () => {
    const visiblePageCount = 5; // Gösterilecek sayfa düğmeleri sayısı
    const pageNumbers = [];

    if (pageCount <= visiblePageCount) {
      // Sayfa sayısı gösterilecek sayfa düğmeleri sayısından küçük veya eşitse, tüm sayfaları göster
      for (let i = 1; i <= pageCount; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Aktif sayfanın etrafında gösterilecek sayfa düğmelerini belirle
      let startPage = Math.max(1, page - Math.floor(visiblePageCount / 2));
      let endPage = Math.min(pageCount, startPage + visiblePageCount - 1);

      if (endPage - startPage + 1 < visiblePageCount) {
        startPage = endPage - visiblePageCount + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }

    const handlePageChange = (newPage) => {
      if (!isCooldown) {
        setIsCooldown(true);
        setPage(newPage);
        setTimeout(() => {
          setIsCooldown(false);
        }, 500);
      }
    };

    return (
      <div className="page-buttons">
        {page > 1 && (
          <div
            className={`page-button next-btn`}
            onClick={() => handlePageChange(page - 1)}
          >
            {"« Previous"}
          </div>
        )}
        {pageNumbers.map((item) => (
          <div
            key={`page-${item}`}
            className={`page-button ${page === item ? "active" : ""}`}
            onClick={() => handlePageChange(item)}
          >
            {item}
          </div>
        ))}

        {pageCount > visiblePageCount &&
          pageNumbers[pageNumbers.length - 1] !== pageCount && (
            <div className="page-button disabled">...</div>
          )}
        {page < pageCount && (
          <div
            className={`page-button next-btn`}
            onClick={() => handlePageChange(page + 1)}
          >
            {"Next »"}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    const fetchNewsUpdates = async () => {
      setLoading(true);
      let result = await axios.get(
        `https://www.damenmc.com/wp-json/wp/v2/posts?categories=${category}&per_page=12&page=${page}&search=${searchParam}`
      );
      await setAxiosData(result.data);
      await sleep(500);
      setLoading(false);
    };
    fetchNewsUpdates();
  }, [page, category, searchParam]);

  useEffect(() => {
    const fetchPageCount = async () => {
      const count = await findPageCount(category);
      setPageCount(count);
    };
    fetchPageCount();
  }, [category]);

  const newsSkeleton = (skeletonCount) => {
    const items = []; // Initialize an empty array to store JSX elements

    for (let i = 0; i < skeletonCount; i++) {
      items.push(
        <div key={i} className="single-news-item">
          {" "}
          {/* Add a unique key prop */}
          <Skeleton height={300} />
          <Skeleton height={15} style={{ marginTop: "10px" }} />
          <Skeleton height={15} style={{ marginTop: "5px" }} />
        </div>
      );
    }

    return items; // Return the array containing all JSX elements
  };

  const newsCategories = [
    { id: 44, name: "All" },
    { id: 63, name: "Yachting" },
    { id: 67, name: "Inland Shipping" },
    { id: 73, name: "Dredging" },
    { id: 71, name: "Short Sea" },
    { id: 69, name: "Oceangoing" },
    { id: 61, name: "Fishery" },
    { id: 65, name: "Defence & Security" },
    { id: 79, name: "Harbour & Terminal" },
  ];

  const handleCategoryChange = (categoryId) => {
    const handlePageChange = (newPage) => {
      if (!isCooldown) {
        setIsCooldown(true);
        setPage(newPage);
        setTimeout(() => {
          setIsCooldown(false);
        }, 500);
      }
    };

    setCategory(categoryId);
    handlePageChange(1);
  };

  const insertSearchParam = async () => {
    const handlePageChange = (newPage) => {
      if (!isCooldown) {
        setIsCooldown(true);
        setPage(newPage);
        setTimeout(() => {
          setIsCooldown(false);
        }, 500);
      }
    };

    setSearchParam(searchText);
    setSearchText("");
    handlePageChange(1);
  };

  return (
    <div id="news-updates">
      <div id="search-filter">
        <div className="search-bar-container">
          <h2 className="news-main-header">Discover our news</h2>
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search here..."
              className="search-input"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  insertSearchParam();
                }
              }}
            />
            <i
              onClick={() => {
                insertSearchParam();
              }}
              className="fa-solid fa-magnifying-glass"
            ></i>
          </div>

          {searchParam.length > 1 ? (
            <div className="current-search">
              <span
                onClick={() => setSearchParam("")}
                className="search-param-span"
              >
                {searchParam}
                <i className="fa-solid fa-x"></i>
              </span>
            </div>
          ) : null}
        </div>
        <div className="filters">
          {newsCategories.map((cat) => (
            <span
              key={cat.id}
              className={`filter-${cat.name
                .toLowerCase()
                .replace(/&/g, "")
                .replace(/\s+/g, "-")} single-filter`}
              onClick={() => handleCategoryChange(cat.id)}
              style={{
                borderBottom:
                  category === cat.id ? "3px solid #2446B1" : "none",
              }}
            >
              {cat.name}
            </span>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="news-items-block">{newsSkeleton(12)}</div>
      ) : (
        <>
          <NewsBlock data={axiosData} />
        </>
      )}
      {searchParam?.length ? null : createPageButtons()}
    </div>
  );
};

export default NewsUpdates;
